export const assessmentTemplate = [
  {
    _id: "pcrHairLoss",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "3",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "rlund3",
      createdDate: "2024-01-11T00:00:00Z",
      modifiedBy: "rickyadmin",
      modifiedDate: "2024-01-11T00:00:00Z",
      isActive: true,
    },
    omniData: {
      omniType: "pcrHairLoss",
      omniTypeVersion: 1,
      title: "Male Pattern Baldness",
      purpose: "Pre-screen specific info for hair loss related trials",
      description:
        "The information you provide will help us understand your personal health needs. We use this to match you to clinical trials.",
      duration: "Around 5 minutes",
      directions:
        "Follow the onscreen instructions after you begin.</br></br>You can take this assessment again any time you experince a change in your health.",
      attribution: "",
      validated: "false",
      selfAssessment: true,
      startDate: null,
      completeDate: null,
      questions: [
        {
          omniID: "hp1",
          shortTitle: "subjectOver18",
          numberText: "1",
          text: "Are you a male 18 or older? ",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "yes",
              text: "Yes",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "no",
              text: "No",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "hp2",
          shortTitle: "subjectHairLossClassification",
          numberText: "2",
          text: "Currently, which pattern below best describes your hair loss?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "image",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "c3",
              text: "Class III",
              subText:
                "https://omni-public-media.s3.us-west-2.amazonaws.com/assessments/hairlossPrescreen/typeIII.png",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "c3v",
              text: "Class IIIv",
              subText:
                "https://omni-public-media.s3.us-west-2.amazonaws.com/assessments/hairlossPrescreen/typeIIIv.png",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "c4",
              text: "Class IV",
              subText:
                "https://omni-public-media.s3.us-west-2.amazonaws.com/assessments/hairlossPrescreen/typeIV.png",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
            {
              value: "c5",
              text: "Class V",
              subText:
                "https://omni-public-media.s3.us-west-2.amazonaws.com/assessments/hairlossPrescreen/typeV.png",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "hp3",
          shortTitle: "subjectMedicalProcedures",
          numberText: "3",
          text: "Have you ever had any of the following medical procedures?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "hairTransplant",
              text: "Hair scalp transplant",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isExclusive: false,
              isLast: false,
            },
            {
              value: "hairWeavesWigsBonding",
              text: "Hair weaves, non-breathable wigs, or hair bonding",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "topicalScalpTreatment",
              text: "Topical scalp treatments",
              subText: "(minoxidil, hormone therapy, etc.)",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "dermatologicalScalpConditions",
              text: "Dermatological conditions of the scalp",
              subText: "(eczema, psoriasis, etc.)",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "none",
              text: "None of the Above",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "hp4",
          shortTitle: "subjectMedications4Month",
          numberText: "4",
          text: "In the last 4 months have you used any of the following medications?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "betaBlockers",
              text: "Beta-blockers",
              subText: "(metoprolol, propranolol, atenolol, etc.)",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "diazoxide",
              text: "Diazoxide",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "cimetidine",
              text: "Cimetidine",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "corticosteroids",
              text: "Corticosteroids by mouth or injection",
              subText: "(prednisone, solumedrol, hydrocortisone)",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "none",
              text: "None of the Above",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "hp5",
          shortTitle: "subjectMedications3Months",
          numberText: "5",
          text: "In the last 3 months have you used any of the following medications?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "spironolactone",
              text: "Spironolactone",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "anabolicSteroids",
              text: "Anabolic Steroids",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "growthHormones",
              text: "Any hormone therapy",
              subText: "(testoserone, etc.)",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "none",
              text: "None of the Above",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "hp6",
          shortTitle: "subjectMedications6MonthsA",
          numberText: "6",
          text: "In the last 6 months have you used any of the following?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "retinoids",
              text: "Retinoids",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "vitaminA",
              text: "High dose vitamin A",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "isotretinoin",
              text: "Isotretinoin",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "none",
              text: "None of the Above",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "hp7",
          shortTitle: "subjectMedications6MonthsB",
          numberText: "7",
          text: "In the last 6 months have you used any of the following?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "finasteride",
              text: "Finasteride",
              subText: "Propecia",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "dutasteride",
              text: "Dutasteride",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "cyclosporine",
              text: "Cyclosporine",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "none",
              text: "None of the Above",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "hp8",
          shortTitle: "subjectExperimentalTreatments",
          numberText: "8",
          text: "In the last 6 months have you had any of the following experimental procedures?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "laser",
              text: "Laser treatment to scalp",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "light",
              text: "Light treatment to scalp",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "plasmaRichProtein",
              text: "Plasma rich protein applications to scalp",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "none",
              text: "None of the Above",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "hp9",
          shortTitle: "subjectOtherSymptomsAnswer",
          numberText: "9",
          text: "Use the box below to give us additional information about your hair loss:",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "freeText",
          answerOptions: [
            {
              value: "",
              text: "",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "hp10",
          shortTitle: "subjectPreviousTrialParticipation",
          numberText: "10",
          text: "Have you participated in any other clinical trials for hair loss?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "yes",
              text: "Yes",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "no",
              text: "No",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
      ],
      assessmentResults: { finalResult: null },
    },
  },
];
export const assessmentScoring = [
  {
    typeID: "phq9",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 0,
        formula: null,
        questions: [],
      },
    ],
  },
];
